import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

const rateEntrySchema = z.object({
  shipmentId: z.string(),
  rateId: z.string(),
  carrierAccountId: z.string(),
  carrier: z.string(),
  service: z.string(),
  rate: z.string().nullish(),
  provider: z.string().nullish(),
});

export type FulfillmentGroupRateEntry = z.infer<typeof rateEntrySchema>;

export const getFulfillmentGroupRatesInfo = {
  name: "getFulfillmentGroupRatesInfo" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({
    boughtRates: z.array(rateEntrySchema),
    availableEasypostRates: z.array(rateEntrySchema),
  }),
};
